import { defineStore } from 'pinia'
import { computed, Ref, ref } from 'vue'

import { UserDependentStore } from './UserDependentStore'
import { MaterialListItem } from '@/types/material'

const maxQueueSize = 15

/** store for recently viewed materials */
export const useMaterialHistoryStore = defineStore('materialHistoryStore', () => {
    /********************************************************************************************************************
     STATE
     ********************************************************************************************************************/
    const _queue: Ref<MaterialListItem[]> = ref([])
    const state = { _queue }

    /********************************************************************************************************************
     GETTERS
     ********************************************************************************************************************/
    const recentlyViewed = computed(() => [..._queue.value].reverse())
    const getters = { recentlyViewed }

    /********************************************************************************************************************
     ACTIONS
     ********************************************************************************************************************/
    function addEntry(material: MaterialListItem) {
        // remove existing entry, if duplicated
        _queue.value = _queue.value.filter(m => m.materialNo != material.materialNo)

        _queue.value.push(material)

        if (_queue.value.length > maxQueueSize) {
            _queue.value.shift();
        }
    }

    function reset() {
        _queue.value = []
    }
     
    const actions = { addEntry, reset }

    /********************************************************************************************************************
     INIT
     ********************************************************************************************************************/
    new UserDependentStore(() => reset(), () => reset())

    /********************************************************************************************************************
     MISC
     ********************************************************************************************************************/    
    return { ...state, ...getters, ...actions }
})